module.exports = __webpack_public_path__ + "img/feat_unified.6b8336be.png";